import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import {
  FormErrorMessages,
  TextInput,
  generateValidation,
  SharedFormMessages as formMessages,
} from 'ecs-react-components/dist/index.es';
import { FormLabel } from 'react-bootstrap';
import { messages } from './ChangeEmail.i18n';
import { validations } from './ChangeEmail.validations';
import { updateEmail } from '../../../redux/modules/account-settings/account-settings-middleware';
import * as MsgBarActions from '../../../redux/modules/system-shared/message-bar-action-creator';

class ChangeEmail extends Component {
  onSubmit = (values) => {
    const { patient, user, usePrimaryEmail } = this.props;
    let isPatient = false;
    if (patient.userId === user.userId) {
      isPatient = true;
    }
    const creds = {
      isPatient,
      usePrimaryEmail,
      userId: user.userId,
      patientId: patient.patientId,
      email: values.userEmail,
    };
    if (user.email.toLowerCase() !== values.userEmail.toLowerCase()) {
      this.props.dispatch(updateEmail(creds, this.props.language));
      return;
    }
    this.props.dispatch(MsgBarActions.showSuccessMessage('emailNotUpdatedMessage'));
  }

  clearAlert = () => {
    this.props.dispatch(MsgBarActions.dismissMessage());
  }

  renderField = (fieldMeta) => (
    <div className="mb-3">
        <TextInput
          labelText=""
          field={fieldMeta}
          email={validations.userEmail}
          qaTag="userEmail"
        />
        {
          fieldMeta.meta.error ?
            <label htmlFor={fieldMeta.input.name}>
              <FormErrorMessages field={fieldMeta}
                customMessage={<FormattedMessage { ...formMessages.error.email } />}
              />
            </label> :
            null
        }
    </div>
  )

  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="settings-section">
        <h4 className="mt-2"><FormattedMessage { ...messages.title } /></h4>
        <p><FormattedMessage {...messages.description} /></p>
        <div className="row">
          <form
            className="col-sm-4"
            onSubmit={ handleSubmit(this.onSubmit) }
            onChange={this.props.onFormChange}
          >
            <FormLabel htmlFor="userEmail" hidden>E-mail</FormLabel>
            <Field id="useEmail" name="userEmail" component={this.renderField} />
            <button type="submit" className="btn btn-primary"
              data-qa-item="change_email" onClick={ this.clearAlert}
            >
              <FormattedMessage { ...messages.button } />
            </button>
          </form>
        </div>
      </div>
    );
  }
}

ChangeEmail.propTypes = {
  dispatch: PropTypes.func,
  handleSubmit: PropTypes.func,
  patient: PropTypes.object,
  user: PropTypes.object,
  onFormChange: PropTypes.func,
  userEmail: PropTypes.string,
  usePrimaryEmail: PropTypes.bool,
  onChange: PropTypes.func,
  language: PropTypes.string,
};

const mapStateToProps = (state) => ({
  patient: state.profile.patient,
  user: state.profile.user,
  usePrimaryEmail: state.accountSettings.patientReminderSettings.usePrimaryEmail,
  userEmail: state.profile.user.email,
  language: state.language.languageCode,
  initialValues: {
    userEmail: state.profile.user.email,
  },
});

const formConfig = {
  form: 'changeemailform',
  ...generateValidation(validations),
};

export default ((connect(mapStateToProps)(reduxForm(formConfig)(ChangeEmail))));
